export const DAY_NAMES = ['일', '월', '화', '수', '목', '금', '토']
export const DEFAULT_DATE_FORMAT = 'YYYYMMDD'
export const REQUIRE_2FA = '2fa'
export const SERVER_CODE_2FA = '112'
export const DEFAULT_CODE = '005930' // 22.05.17 suye 종목입체분석 종목 기본값 000660 -> 005930
export const DEFAULT_NAME = '삼성전자' // 220608 meej 종목히스토리 검색 종목 기본값

export const APP_VERSION = '1.0.0'
